import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, CircularProgress, Container, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import LinksListResults from '../../components/Links/LinksListResults';
import LinksListToolbar from '../../components/Links/LinksListToolbar';
import affiliateService from '../../services/affiliateService';

const LinksList = () => {
  const auth = useSelector((state) => state.auth);
  const [isLoadingRegs, setIsLoadingRegs] = useState(true);
  const [regs, setRegs] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [total, setTotal] = useState(0);

  const get = async () => {
    setIsLoadingRegs(true);
    setRegs([]);

    try {
      const params = {
        page,
        per_page: perPage
      };

      const response = await affiliateService.getAffiliateLinks(auth.token, params);

      if (!response || !response.data) {
        throw new Error('Erro ao buscar links');
      }

      setRegs(response.data.data || []);
      setPage(response.data.page || 1);
      setPerPage(response.data.perPage || 25);
      setTotal(response.data.total || 0);
    } catch (e) {
      console.error(e);
      swal('Erro', 'Erro ao buscar links de afiliado', 'error');
    } finally {
      setIsLoadingRegs(false);
    }
  };

  useEffect(() => {
    get();
  }, [page, perPage]);

  const handleToggleActive = async (id, currentStatus) => {
    try {
      const response = await affiliateService.updateAffiliateLink(
        id,
        { active: !currentStatus },
        auth.token
      );

      if (response && response.data) {
        swal('Sucesso', `Link ${!currentStatus ? 'ativado' : 'desativado'} com sucesso!`, 'success');
        get();
      } else {
        throw new Error('Erro ao atualizar link');
      }
    } catch (e) {
      console.error(e);
      swal('Erro', 'Erro ao atualizar status do link', 'error');
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = await swal({
      title: 'Tem certeza?',
      text: 'Deseja realmente deletar este link?',
      icon: 'warning',
      buttons: ['Cancelar', 'Deletar'],
      dangerMode: true
    });

    if (!confirmDelete) return;

    try {
      const response = await affiliateService.deleteAffiliateLink(id, auth.token);

      if (response) {
        swal('Sucesso', 'Link deletado com sucesso!', 'success');
        get();
      } else {
        throw new Error('Erro ao deletar link');
      }
    } catch (e) {
      console.error(e);
      swal('Erro', 'Erro ao deletar link', 'error');
    }
  };

  return (
    <>
      <Helmet>
        <title>Meus Links | Sistema de Afiliados</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <LinksListToolbar onRefresh={get} />
          {isLoadingRegs && (
            <Box sx={{ pt: 3 }}>
              <Typography align="center" variant="h5" color="primary">
                <CircularProgress color="primary" sx={{ mb: 3 }} />
                <br />
                Buscando informações, por favor aguarde...
              </Typography>
            </Box>
          )}
          {!isLoadingRegs && (!regs || regs.length === 0) && (
            <Box sx={{ pt: 3 }}>
              <Typography align="center" variant="h5" color="primary">
                Nenhum link localizado. Crie seu primeiro link!
              </Typography>
            </Box>
          )}
          {!isLoadingRegs && regs && regs.length > 0 && (
            <Box sx={{ pt: 3 }}>
              <LinksListResults
                regs={regs}
                page={page}
                setPage={setPage}
                perPage={perPage}
                setPerPage={setPerPage}
                total={total}
                onToggleActive={handleToggleActive}
                onDelete={handleDelete}
              />
            </Box>
          )}
        </Container>
      </Box>
    </>
  );
};

export default LinksList;
